import { useApiSend } from "@/hooks/useApi";
import { useNavigate } from "react-router-dom";
import { login, loginWithGoogleOAuthCode } from "@/features/auth/api";
import { AUTH_TOKEN_LOCAL_STORAGE_ITEM_NAME } from "@/utils/constants";
import { errorToast, successToast } from "@/ui/toast/Toast";
import i18n from "@/i18n";
import { useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";

export function useLoginWithGoogleOAuthCode() {
	const navigate = useNavigate();
	const queryClient = useQueryClient();

	const { mutateAsync, isPending, isError, error } = useApiSend({
		mutationKeys: ["google-login"],
		fn: loginWithGoogleOAuthCode,
		invalidateKeys: [["whoami"]],
		resetKeys: [["whoami"]],
	});

	const loginMutate = async function ({ code, state }) {
		try {
			if (
				code == null ||
				state == null ||
				state != localStorage.getItem("google-state")
			) {
				throw new Error("invalid-state");
			}

			const res = await mutateAsync({ code });

			localStorage.setItem(AUTH_TOKEN_LOCAL_STORAGE_ITEM_NAME, res.token);

			queryClient.resetQueries({ queryKey: ["whoami"] });

			if (res.has_completed_registration) {
				// i18n.t at this moment, not earlier: the language may have
				// changed while the request was in flight.
				successToast(i18n.t("auth:google.success"));
				navigate("/", { replace: true });
			} else {
				navigate("/register", { replace: true });
			}
		} catch (e) {
			errorToast(i18n.t("auth:google.error"));
			navigate("/login/", { replace: true });
		}
	};

	return { login: loginMutate, isPending, error, isError };
}
